"use strict";
( () => {
    var m = (n, t) => () => (t || n((t = {
        exports: {}
    }).exports, t),
    t.exports);
    var k = m( (Be, Gt) => {
        "use strict";
        var f = class {
            constructor(t, s) {
                this.x = t,
                this.y = s
            }
            equals(t) {
                return this.x === t.x && this.y === t.y
            }
            toString() {
                return `P(${this.x}, ${this.y})`
            }
            distance(t) {
                return Math.sqrt((this.x - t.x) ** 2 + (this.y - t.y) ** 2)
            }
            distanceSquared(t) {
                return (this.x - t.x) ** 2 + (this.y - t.y) ** 2
            }
        }
          , b = class n {
            constructor(t, s) {
                if (!(t instanceof f) || !(s instanceof f))
                    throw new Error("Start and end must be Point instances");
                this.start = t,
                this.end = s
            }
            equals(t) {
                return t instanceof n ? this.start.equals(t.start) && this.end.equals(t.end) : !1
            }
            toString() {
                return `S(${this.start}, ${this.end})`
            }
            get lengthSquared() {
                return this.start.distanceSquared(this.end)
            }
            get length() {
                return this.start.distance(this.end)
            }
            get top() {
                return Math.max(this.start.y, this.end.y)
            }
            get bottom() {
                return Math.min(this.start.y, this.end.y)
            }
            get right() {
                return Math.max(this.start.x, this.end.x)
            }
            get left() {
                return Math.min(this.start.x, this.end.x)
            }
        }
          , J = class extends b {
            constructor(t, s) {
                if (!(t instanceof f) || typeof s != "number")
                    throw new Error("Start must be a Point and length must be a number");
                super(t, new f(t.x + s,t.y))
            }
            get length() {
                return this.end.x - this.start.x
            }
        }
          , K = class extends b {
            constructor(t, s) {
                if (!(t instanceof f) || typeof s != "number")
                    throw new Error("Start must be a Point and length must be a number");
                super(t, new f(t.x,t.y + s))
            }
            get length() {
                return this.end.y - this.start.y
            }
        }
          , H = class n {
            constructor(t, s, e, i, r=null) {
                if (i < 0 || e < 0)
                    throw new Error("Height and width must be non-negative");
                this.width = e,
                this.height = i,
                this.x = t,
                this.y = s,
                this.rid = r
            }
            get bottom() {
                return this.y
            }
            get top() {
                return this.y + this.height
            }
            get left() {
                return this.x
            }
            get right() {
                return this.x + this.width
            }
            get cornerTopL() {
                return new f(this.left,this.top)
            }
            get cornerTopR() {
                return new f(this.right,this.top)
            }
            get cornerBotR() {
                return new f(this.right,this.bottom)
            }
            get cornerBotL() {
                return new f(this.left,this.bottom)
            }
            area() {
                return this.width * this.height
            }
            move(t, s) {
                this.x = t,
                this.y = s
            }
            contains(t) {
                return t.y >= this.y && t.x >= this.x && t.y + t.height <= this.y + this.height && t.x + t.width <= this.x + this.width
            }
            intersects(t, s=!1) {
                if (s) {
                    if (this.bottom > t.top || this.top < t.bottom || this.left > t.right || this.right < t.left)
                        return !1
                } else if (this.bottom >= t.top || this.top <= t.bottom || this.left >= t.right || this.right <= t.left)
                    return !1;
                return !0
            }
            intersection(t, s=!1) {
                if (!this.intersects(t, s))
                    return null;
                let e = Math.max(this.bottom, t.bottom)
                  , i = Math.max(this.left, t.left)
                  , r = Math.min(this.top, t.top)
                  , o = Math.min(this.right, t.right);
                return new n(i,e,o - i,r - e)
            }
            join(t) {
                if (this.contains(t))
                    return !0;
                if (t.contains(this))
                    return this.x = t.x,
                    this.y = t.y,
                    this.width = t.width,
                    this.height = t.height,
                    !0;
                if (!this.intersects(t, !0))
                    return !1;
                if (this.left === t.left && this.width === t.width) {
                    let s = Math.min(this.bottom, t.bottom)
                      , e = Math.max(this.top, t.top);
                    return this.y = s,
                    this.height = e - s,
                    !0
                }
                if (this.bottom === t.bottom && this.height === t.height) {
                    let s = Math.min(this.left, t.left)
                      , e = Math.max(this.right, t.right);
                    return this.x = s,
                    this.width = e - s,
                    !0
                }
                return !1
            }
        }
        ;
        Gt.exports = {
            Point: f,
            Segment: b,
            HSegment: J,
            VSegment: K,
            Rectangle: H
        }
    }
    );
    var X = m( (ge, Tt) => {
        "use strict";
        var {Rectangle: Nt} = k()
          , Q = class {
            constructor(t, s, e=!0, i=null) {
                this.width = t,
                this.height = s,
                this.rot = e,
                this.rectangles = [],
                this.bid = i,
                this._surface = new Nt(0,0,t,s),
                this.reset()
            }
            get length() {
                return this.rectangles.length
            }
            [Symbol.iterator]() {
                return this.rectangles[Symbol.iterator]()
            }
            _fitsSurface(t, s) {
                if (!(t > 0 && s > 0))
                    throw new Error("Width and height must be positive");
                if (this.rot && (t > this.width || s > this.height)) {
                    let e = t;
                    t = s,
                    s = e
                }
                return !(t > this.width || s > this.height)
            }
            getItem(t) {
                return this.rectangles[t]
            }
            usedArea() {
                return this.rectangles.reduce( (t, s) => t + s.area(), 0)
            }
            fitness(t, s, e=!1) {
                throw new Error("Not implemented")
            }
            addRect(t, s, e=null, i=null) {
                throw new Error("Not implemented")
            }
            rectList() {
                return this.rectangles.map(t => [t.x, t.y, t.width, t.height, t.rid])
            }
            validatePacking() {
                let t = new Nt(0,0,this.width,this.height);
                for (let s of this.rectangles)
                    if (!t.contains(s))
                        throw new Error("Rectangle placed outside surface");
                if (!(this.rectangles.length <= 1)) {
                    for (let s = 0; s <= this.rectangles.length - 2; s++)
                        for (let e = s + 1; e <= this.rectangles.length - 1; e++)
                            if (this.rectangles[s].intersects(this.rectangles[e]))
                                throw new Error("Rectangle collision detected")
                }
            }
            isEmpty() {
                return this.rectangles.length === 0
            }
            reset() {
                this.rectangles = []
            }
        }
        ;
        Tt.exports = Q
    }
    );
    var bt = m( (we, At) => {
        "use strict";
        var {Rectangle: g} = k()
          , Yt = X()
          , Zt = n => class extends n {
            constructor(t, s, e=!0, i=!0, ...r) {
                super(t, s, e, ...r),
                this._merge = i,
                this._sections = [],
                this._add_section(new g(0,0,t,s,null))
            }
            _add_section(t) {
                t.rid = 0;
                let s = 0;
                for (; this._merge && this._sections && s !== this._sections.length; )
                    s = this._sections.length,
                    this._sections = this._sections.filter(e => !t.join(e));
                this._sections.push(t)
            }
            _split_horizontal(t, s, e) {
                e < t.height && this._add_section(new g(t.x,t.y + e,t.width,t.height - e)),
                s < t.width && this._add_section(new g(t.x + s,t.y,t.width - s,e))
            }
            _split_vertical(t, s, e) {
                e < t.height && this._add_section(new g(t.x,t.y + e,s,t.height - e)),
                s < t.width && this._add_section(new g(t.x + s,t.y,t.width - s,t.height))
            }
            _split(t, s, e) {
                throw new Error("Not implemented")
            }
            _section_fitness(t, s, e) {
                throw new Error("Not implemented")
            }
            _select_fittest_section(t, s) {
                let e = this._sections.map(c => {
                    let h = this._section_fitness(c, t, s);
                    return h !== null ? [h, c, !1] : null
                }
                ).filter(c => c !== null)
                  , i = [];
                this.rot.rot === !0 && (i = this._sections.map(c => {
                    let h = this._section_fitness(c, s, t);
                    return h !== null ? [h, c, !0] : null
                }
                ).filter(c => c !== null));
                let r = [...e, ...i];
                if (r.length === 0)
                    return [];
                let[o,a,d] = r.reduce( (c, h) => h[0] < c[0] ? h : c);
                return [a, d]
            }
            addRect(t, s, e=null, i=null) {
                if (!(t > 0 && s > 0))
                    throw new Error("Width and height must be positive");
                let[r,o] = this._select_fittest_section(t, s);
                if (!r)
                    return null;
                if (o) {
                    let c = t;
                    t = s,
                    s = c
                }
                let a;
                i && (a = JSON.parse(i)),
                a && a?.isShowFileName && (s = s + a.fileNameSpace),
                this._sections = this._sections.filter(c => c !== r),
                this._split(r, t, s);
                let d = new g(r.x,r.y,t,s,e);
                return this.rectangles.push(d),
                d
            }
            fitness(t, s) {
                if (!(t > 0 && s > 0))
                    throw new Error("Width and height must be positive");
                let[e,i] = this._select_fittest_section(t, s);
                return e ? i ? this._section_fitness(e, s, t) : this._section_fitness(e, t, s) : null
            }
            reset() {
                super.reset(),
                this._sections = [],
                this._add_section(new g(0,0,this.width,this.height))
            }
        }
          , Vt = Zt(Yt)
          , l = class extends Vt {
            constructor(...t) {
                super(...t)
            }
        }
          , Y = class extends l {
            _section_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : t.area() - s * e
            }
        }
          , y = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _section_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : t.area() - s * e
            }
        }
          , Z = class extends l {
            _section_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : Math.max(t.width - s, t.height - e)
            }
        }
          , M = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _section_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : Math.max(t.width - s, t.height - e)
            }
        }
          , V = class extends l {
            _section_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : Math.min(t.width - s, t.height - e)
            }
        }
          , R = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _section_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : Math.min(t.width - s, t.height - e)
            }
        }
          , E = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _split(t, s, e) {
                return t.width < t.height ? this._split_horizontal(t, s, e) : this._split_vertical(t, s, e)
            }
        }
          , ts = E(l)
          , tt = class extends ts {
            constructor(...t) {
                super(...t)
            }
        }
          , F = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _split(t, s, e) {
                return t.width >= t.height ? this._split_horizontal(t, s, e) : this._split_vertical(t, s, e)
            }
        }
          , ss = F(l)
          , st = class extends ss {
            constructor(...t) {
                super(...t)
            }
        }
          , v = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _split(t, s, e) {
                return t.width - s < t.height - e ? this._split_horizontal(t, s, e) : this._split_vertical(t, s, e)
            }
        }
          , es = v(l)
          , et = class extends es {
            constructor(...t) {
                super(...t)
            }
        }
          , P = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _split(t, s, e) {
                return t.width - s < t.height - e ? this._split_horizontal(t, s, e) : this._split_vertical(t, s, e)
            }
        }
          , ns = P(l)
          , nt = class extends ns {
            constructor(...t) {
                super(...t)
            }
        }
          , G = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _split(t, s, e) {
                return t.width - s < t.height - e ? this._split_horizontal(t, s, e) : this._split_vertical(t, s, e)
            }
        }
          , is = G(l)
          , it = class extends is {
            constructor(...t) {
                super(...t)
            }
        }
          , N = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            _split(t, s, e) {
                return s * (t.height - e) >= e * (t.width - s) ? this._split_horizontal(t, s, e) : this._split_vertical(t, s, e)
            }
        }
          , rs = N(l)
          , rt = class extends rs {
            constructor(...t) {
                super(...t)
            }
        }
          , os = E(R(l))
          , ot = class extends os {
            constructor(...t) {
                super(...t)
            }
        }
          , ls = F(R(l))
          , lt = class extends ls {
            constructor(...t) {
                super(...t)
            }
        }
          , cs = v(R(l))
          , ct = class extends cs {
            constructor(...t) {
                super(...t)
            }
        }
          , as = P(R(l))
          , at = class extends as {
            constructor(...t) {
                super(...t)
            }
        }
          , hs = G(R(l))
          , ht = class extends hs {
            constructor(...t) {
                super(...t)
            }
        }
          , us = N(R(l))
          , ut = class extends us {
            constructor(...t) {
                super(...t)
            }
        }
          , fs = E(M(l))
          , ft = class extends fs {
            constructor(...t) {
                super(...t)
            }
        }
          , _s = F(M(l))
          , _t = class extends _s {
            constructor(...t) {
                super(...t)
            }
        }
          , ds = v(M(l))
          , dt = class extends ds {
            constructor(...t) {
                super(...t)
            }
        }
          , ps = P(M(l))
          , pt = class extends ps {
            constructor(...t) {
                super(...t)
            }
        }
          , xs = G(M(l))
          , xt = class extends xs {
            constructor(...t) {
                super(...t)
            }
        }
          , Bs = N(M(l))
          , Bt = class extends Bs {
            constructor(...t) {
                super(...t)
            }
        }
          , gs = E(y(l))
          , gt = class extends gs {
            constructor(...t) {
                super(...t)
            }
        }
          , ws = F(y(l))
          , wt = class extends ws {
            constructor(...t) {
                super(...t)
            }
        }
          , ms = v(y(l))
          , mt = class extends ms {
            constructor(...t) {
                super(...t)
            }
        }
          , ys = P(y(l))
          , yt = class extends ys {
            constructor(...t) {
                super(...t)
            }
        }
          , Ms = G(y(l))
          , Mt = class extends Ms {
            constructor(...t) {
                super(...t)
            }
        }
          , Rs = N(y(l))
          , Rt = class extends Rs {
            constructor(...t) {
                super(...t)
            }
        }
        ;
        At.exports = {
            Guillotine: l,
            GuillotineBaf: Y,
            GuillotineBlsf: Z,
            GuillotineBssf: V,
            GuillotineSas: tt,
            GuillotineLas: st,
            GuillotineSlas: et,
            GuillotineLlas: nt,
            GuillotineMaxas: it,
            GuillotineMinas: rt,
            GuillotineBssfSas: ot,
            GuillotineBssfLas: lt,
            GuillotineBssfSlas: ct,
            GuillotineBssfLlas: at,
            GuillotineBssfMaxas: ht,
            GuillotineBssfMinas: ut,
            GuillotineBlsfSas: ft,
            GuillotineBlsfLas: _t,
            GuillotineBlsfSlas: dt,
            GuillotineBlsfLlas: pt,
            GuillotineBlsfMaxas: xt,
            GuillotineBlsfMinas: Bt,
            GuillotineBafSas: gt,
            GuillotineBafLas: wt,
            GuillotineBafSlas: mt,
            GuillotineBafLlas: yt,
            GuillotineBafMaxas: Mt,
            GuillotineBafMinas: Rt
        }
    }
    );
    var It = m( (ve, Lt) => {
        "use strict";
        var {GuillotineBssfSas: $} = bt();
        function bs(n, t) {
            return Number(Math.ceil(n * Math.pow(10, t)) / Math.pow(10, t))
        }
        var qt = n => [...n].sort( (t, s) => s[0] * s[1] - t[0] * t[1])
          , Ss = n => [...n].sort( (t, s) => s[0] + s[1] - (t[0] + t[1]))
          , Os = n => [...n].sort( (t, s) => Math.abs(s[0] - s[1]) - Math.abs(t[0] - t[1]))
          , ks = n => [...n].sort( (t, s) => {
            let[e,i] = [Math.min(t[0], t[1]), Math.max(t[0], t[1])]
              , [r,o] = [Math.min(s[0], s[1]), Math.max(s[0], s[1])];
            return r - e || o - i
        }
        )
          , Es = n => [...n].sort( (t, s) => {
            let[e,i] = [Math.max(t[0], t[1]), Math.min(t[0], t[1])]
              , [r,o] = [Math.max(s[0], s[1]), Math.min(s[0], s[1])];
            return r - e || o - i
        }
        )
          , Fs = n => [...n].sort( (t, s) => s[0] / s[1] - t[0] / t[1])
          , St = n => [...n]
          , T = {
            Online: 0,
            Offline: 1,
            properties: {
                0: {
                    name: "Online"
                },
                1: {
                    name: "Offline"
                }
            }
        }
          , x = {
            BNF: 0,
            BFF: 1,
            BBF: 2,
            Global: 3,
            properties: {
                0: {
                    name: "BNF"
                },
                1: {
                    name: "BFF"
                },
                2: {
                    name: "BBF"
                },
                3: {
                    name: "Global"
                }
            }
        }
          , A = class {
            constructor(t, s, e, i, ...r) {
                this._width = t,
                this._height = s,
                this._count = e,
                this._packAlgo = i,
                this._algoArgs = r,
                this._refBin = null
            }
            _createBin() {
                return new this._packAlgo(this._width,this._height,...this._algoArgs)
            }
            isEmpty() {
                return this._count < 1
            }
            fitness(t, s) {
                return this._refBin || (this._refBin = this._createBin()),
                this._refBin.fitness(t, s)
            }
            fitsInside(t, s) {
                return this._refBin || (this._refBin = this._createBin()),
                this._refBin._fitsSurface(t, s)
            }
            newBin() {
                return this._count > 0 ? (this._count--,
                this._createBin()) : null
            }
        }
          , p = class {
            constructor({packAlgo: t=$, rotation: s=!0}) {
                this._rotation = s,
                this._packAlgo = t,
                this.reset()
            }
            *[Symbol.iterator]() {
                yield*[...this._closedBins, ...this._openBins]
            }
            get length() {
                return this._closedBins.length + this._openBins.length
            }
            _newOpenBin(t=null, s=null, e=null) {
                let i = new Set
                  , r = null;
                for (let[o,a] of Object.entries(this._emptyBins))
                    if (a.fitsInside(t, s) && (r = a.newBin(),
                    !!r)) {
                        this._openBins.push(r),
                        a.isEmpty() && i.add(o);
                        break
                    }
                return i.forEach(o => delete this._emptyBins[o]),
                r
            }
            addBin(t, s, e=1, i={}) {
                i.rot = this._rotation;
                let r = new A(t,s,e,this._packAlgo,i);
                this._emptyBins[this._binCount++] = r
            }
            rectList() {
                let t = []
                  , s = 0;
                for (let e of this) {
                    for (let i of e)
                        t.push([s, i.x, i.y, i.width, i.height, i.rid]);
                    s++
                }
                return t
            }
            binList() {
                return [...this].map(t => [t.width, t.height])
            }
            validatePacking() {
                for (let t of this)
                    t.validatePacking()
            }
            reset() {
                this._closedBins = [],
                this._openBins = [],
                this._emptyBins = new Map,
                this._binCount = 0
            }
        }
          , U = n => class extends n {
            constructor({packAlgo: t=$, sortAlgo: s=St, rotation: e=!0}={}) {
                super({
                    packAlgo: t,
                    rotation: e
                }),
                this._sortAlgo = s,
                this._availBins = [],
                this._availRect = [],
                this._sortedRect = []
            }
            addBin(t, s, e=1, i={}) {
                this._availBins.push([t, s, e, i])
            }
            addRect(t, s, e=null, i=null) {
                this._availRect.push([t, s, e, i])
            }
            addRectOffline(t, s, e=null, i=null) {
                this._availRect.push([t, s, e, i])
            }
            _isEverythingReady() {
                return this._availRect.length > 0 && this._availBins.length > 0
            }
            pack() {
                if (this.reset(),
                !!this._isEverythingReady()) {
                    for (let t = 0; t < this._availBins.length; t++) {
                        let[s,e,i,r] = this._availBins[t];
                        super.addBin(s, e, i, r)
                    }
                    this._sortedRect = this._sortAlgo(this._availRect);
                    for (let t of this._sortedRect)
                        super.addRect(...t)
                }
            }
        }
          , vs = U(p)
          , q = class extends vs {
            constructor(...t) {
                super(...t)
            }
        }
          , S = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            addRect(t, s, e=null, i=null) {
                for (; ; ) {
                    if (this._openBins.length === 0 && !this._newOpenBin(t, s, e, i))
                        return null;
                    let r = this._openBins[0].addRect(t, s, e, i);
                    if (r)
                        return r;
                    let o = this._openBins.shift();
                    this._closedBins.push(o)
                }
            }
        }
          , Ot = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            addRect(t, s, e=null, i=null) {
                for (let r of this._openBins) {
                    let o = r.addRect(t, s, e, i);
                    if (o)
                        return o
                }
                for (; ; ) {
                    let r = this._newOpenBin(t, s, e, i);
                    if (!r)
                        return null;
                    let o = r.addRect(t, s, e, i);
                    if (o)
                        return o
                }
            }
        }
          , kt = n => class extends n {
            constructor(...t) {
                super(...t)
            }
            addRect(t, s, e=null, i=null) {
                let r = this._openBins.map(o => [o.fitness(t, s), o]).filter( ([o]) => o !== null);
                if (r.length > 0) {
                    let[o,a] = r.reduce( (d, c) => c[0] < d[0] ? c : d);
                    return a.addRect(t, s, e, i),
                    !0
                }
                for (; ; ) {
                    let o = this._newOpenBin(t, s, e, i);
                    if (!o)
                        return !1;
                    if (o.addRect(t, s, e, i))
                        return !0
                }
            }
        }
          , Ps = U(S(p))
          , L = class extends Ps {
            constructor(...t) {
                super(...t)
            }
        }
          , Gs = U(Ot(p))
          , I = class extends Gs {
            constructor(...t) {
                super(...t)
            }
        }
          , Ns = U(kt(p))
          , j = class extends Ns {
            constructor(...t) {
                super(...t)
            }
        }
          , Ts = S(p)
          , z = class extends Ts {
            constructor(...t) {
                super(...t)
            }
        }
          , As = Ot(p)
          , D = class extends As {
            constructor(...t) {
                super(...t)
            }
        }
          , qs = kt(p)
          , W = class extends qs {
            constructor(...t) {
                super(...t)
            }
        }
          , Ls = S(q)
          , C = class extends Ls {
            constructor({packAlgo: t=$, rotation: s=!0}={}) {
                super({
                    packAlgo: t,
                    sortAlgo: St,
                    rotation: s
                })
            }
            _findBestFit(t) {
                let s = Object.entries(this._sortedRect).map( ([r,o]) => [t.fitness(o[0], o[1]), r]).filter( ([r]) => r !== null);
                if (s.length === 0)
                    return null;
                let[e,i] = s.reduce( (r, o) => o[0] < r[0] ? o : r);
                return i
            }
            _newOpenBin(t) {
                let s = new Set
                  , e = null;
                for (let[i,r] of Object.entries(this._emptyBins)) {
                    let o = !1;
                    for (let a of Object.values(t))
                        if (r.fitsInside(a[0], a[1])) {
                            o = !0;
                            break
                        }
                    if (!o) {
                        s.add(i);
                        continue
                    }
                    if (e = r.newBin(),
                    !!e) {
                        this._openBins.push(e),
                        r.isEmpty() && s.add(i);
                        break
                    }
                }
                for (let i of s)
                    delete this._emptyBins[i];
                return e
            }
            pack() {
                if (this.reset(),
                !!this._isEverythingReady())
                    for (this._sortedRect = Object.fromEntries(this._sortAlgo(this._availRect).map( (t, s) => [s, t])); Object.keys(this._sortedRect).length > 0; ) {
                        let t = this._newOpenBin(this._sortedRect);
                        if (!t)
                            break;
                        for (; ; ) {
                            let s = this._findBestFit(t);
                            if (!s) {
                                let i = this._openBins.shift();
                                this._closedBins.push(i);
                                break
                            }
                            let e = this._sortedRect[s];
                            delete this._sortedRect[s],
                            S.prototype.addRect.call(this, ...e)
                        }
                    }
            }
        }
        ;
        function Is({mode: n=T.Offline, binAlgo: t=x.BBF, packAlgo: s=$, sortAlgo: e=qt, rotation: i=!0}={}) {
            let r = null;
            if (n === T.Online)
                switch (e = null,
                t) {
                case x.BNF:
                    r = z;
                    break;
                case x.BFF:
                    r = D;
                    break;
                case x.BBF:
                    r = W;
                    break;
                default:
                    throw new Error("Unsupported bin selection heuristic")
                }
            else if (n === T.Offline)
                switch (t) {
                case x.BNF:
                    r = L;
                    break;
                case x.BFF:
                    r = I;
                    break;
                case x.BBF:
                    r = j;
                    break;
                case x.Global:
                    r = C,
                    e = null;
                    break;
                default:
                    throw new Error("Unsupported bin selection heuristic")
                }
            else
                throw new Error("Unknown packing mode");
            return e ? new r({
                packAlgo: s,
                sortAlgo: e,
                rotation: i
            }) : new r({
                packAlgo: s,
                rotation: i
            })
        }
        Lt.exports = {
            float2dec: bs,
            SORT_AREA: qt,
            SORT_PERI: Ss,
            SORT_DIFF: Os,
            SORT_SSIDE: ks,
            SORT_LSIDE: Es,
            SORT_RATIO: Fs,
            SORT_NONE: St,
            BinFactory: A,
            PackerBNFMixin: S,
            PackerBFFMixin: Ot,
            PackerBBFMixin: kt,
            PackerOnline: p,
            Packer: q,
            PackerBNF: L,
            PackerBFF: I,
            PackerBBF: j,
            PackerOnlineBNF: z,
            PackerOnlineBFF: D,
            PackerOnlineBBF: W,
            PackerGlobal: C,
            PackingMode: T,
            PackingBin: x,
            newPacker: Is
        }
    }
    );
    var zt = m( (Ae, jt) => {
        "use strict";
        var {Rectangle: B} = k()
          , js = X()
          , w = class extends js {
            constructor(t, s, e=!0, ...i) {
                super(t, s, e, ...i),
                this._max_rects = [new B(0,0,t,s)]
            }
            _rect_fitness(t, s, e) {
                return s <= t.width && e <= t.height ? 0 : null
            }
            _select_position(t, s) {
                if (!this._max_rects.length)
                    return [null, null];
                let e = this._max_rects.map(h => {
                    let _ = this._rect_fitness(h, t, s);
                    return _ !== null ? [_, t, s, h] : null
                }
                ).filter(h => h !== null)
                  , i = [];
                this.rot && (i = this._max_rects.map(h => {
                    let _ = this._rect_fitness(h, s, t);
                    return _ !== null ? [_, s, t, h] : null
                }
                ).filter(h => h !== null));
                let r = [...e, ...i];
                if (r.length === 0)
                    return [null, null];
                let[o,a,d,c] = r.reduce( (h, _) => _[0] < h[0] ? _ : h);
                return [new B(c.x,c.y,a,d), c]
            }
            _generate_splits(t, s) {
                let e = [];
                return s.x > t.x && e.push(new B(t.x,t.y,s.x - t.x,t.height)),
                s.x + s.width < t.x + t.width && e.push(new B(s.x + s.width,t.y,t.x + t.width - (s.x + s.width),t.height)),
                s.y + s.height < t.y + t.height && e.push(new B(t.x,s.y + s.height,t.width,t.y + t.height - (s.y + s.height))),
                s.y > t.y && e.push(new B(t.x,t.y,t.width,s.y - t.y)),
                e
            }
            _split(t) {
                let s = [];
                for (let e of this._max_rects)
                    e.intersects(t) ? s.push(...this._generate_splits(e, t)) : s.push(e);
                this._max_rects = s
            }
            _remove_duplicates() {
                let t = new Set;
                for (let s = 0; s < this._max_rects.length; s++)
                    for (let e = s + 1; e < this._max_rects.length; e++) {
                        let i = this._max_rects[s]
                          , r = this._max_rects[e];
                        i.contains(r) ? t.add(r) : r.contains(i) && t.add(i)
                    }
                this._max_rects = this._max_rects.filter(s => !t.has(s))
            }
            fitness(t, s) {
                if (!(t > 0 && s > 0))
                    throw new Error("Width and height must be positive");
                let[e,i] = this._select_position(t, s);
                return e ? this._rect_fitness(i, e.width, e.height) : null
            }
            addRect(t, s, e=null, i=null) {
                if (!(t > 0 && s > 0))
                    throw new Error("Width and height must be positive");
                let[r,o] = this._select_position(t, s);
                if (!r)
                    return null;
                let a;
                return i && (a = JSON.parse(i)),
                a && a?.isShowFileName && (r.height = r.height + a.fileNameSpace),
                this._split(r),
                this._remove_duplicates(),
                r.rid = e,
                this.rectangles.push(r),
                r
            }
            reset() {
                super.reset(),
                this._max_rects = [new B(0,0,this.width,this.height)]
            }
        }
          , Et = class extends w {
            _select_position(t, s) {
                if (!this._max_rects.length)
                    return [null, null];
                let e = t >= 802.5 && t <= 843.75 && s >= 885.9530386740331 && s <= 931.5331491712708
                  , i = this._max_rects.map(u => this._rect_fitness(u, t, s) !== null ? [u.y + s, u.x, t, s, u] : null).filter(u => u !== null)
                  , r = [];
                this.rot && !e && (r = this._max_rects.map(u => this._rect_fitness(u, s, t) !== null ? [u.y + t, u.x, s, t, u] : null).filter(u => u !== null));
                let o = [...i, ...r];
                if (o.length === 0)
                    return [null, null];
                let[a,d,c,h,_] = o.reduce( (u, O) => O[0] < u[0] ? O : u);
                return [new B(_.x,_.y,c,h), _]
            }
        }
          , Ft = class extends w {
            _rect_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : Math.min(t.width - s, t.height - e)
            }
        }
          , vt = class extends w {
            _rect_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : t.width * t.height - s * e
            }
        }
          , Pt = class extends w {
            _rect_fitness(t, s, e) {
                return s > t.width || e > t.height ? null : Math.max(t.width - s, t.height - e)
            }
        }
        ;
        jt.exports = {
            MaxRects: w,
            MaxRectsBl: Et,
            MaxRectsBssf: Ft,
            MaxRectsBaf: vt,
            MaxRectsBlsf: Pt
        }
    }
    );
    var pe = m( (qe, Xt) => {
        var {GuillotineBssfSas: Dt, GuillotineBssfLas: zs, GuillotineBssfSlas: Ds, GuillotineBssfLlas: Ws, GuillotineBssfMaxas: Cs, GuillotineBssfMinas: $s, GuillotineBlsfSas: Us, GuillotineBlsfLas: Js, GuillotineBlsfSlas: Ks, GuillotineBlsfLlas: Hs, GuillotineBlsfMaxas: Qs, GuillotineBlsfMinas: Xs, GuillotineBafSas: Ys, GuillotineBafLas: Zs, GuillotineBafSlas: Vs, GuillotineBafLlas: te, GuillotineBafMaxas: se, GuillotineBafMinas: ee} = bt()
          , {float2dec: ne, SORT_AREA: Wt, SORT_PERI: ie, SORT_DIFF: re, SORT_SSIDE: oe, SORT_LSIDE: le, SORT_RATIO: ce, SORT_NONE: ae, BinFactory: he, PackerBNFMixin: ue, PackerBFFMixin: fe, PackerBBFMixin: _e, PackerOnline: de, PackingMode: Ct, PackingBin: $t, newPacker: Ut} = It()
          , {MaxRectsBl: Jt, MaxRectsBssf: Kt, MaxRectsBaf: Ht, MaxRectsBlsf: Qt} = zt();
        Xt.exports = {
            GuillotineBssfSas: Dt,
            GuillotineBssfLas: zs,
            GuillotineBssfSlas: Ds,
            GuillotineBssfLlas: Ws,
            GuillotineBssfMaxas: Cs,
            GuillotineBssfMinas: $s,
            GuillotineBlsfSas: Us,
            GuillotineBlsfLas: Js,
            GuillotineBlsfSlas: Ks,
            GuillotineBlsfLlas: Hs,
            GuillotineBlsfMaxas: Qs,
            GuillotineBlsfMinas: Xs,
            GuillotineBafSas: Ys,
            GuillotineBafLas: Zs,
            GuillotineBafSlas: Vs,
            GuillotineBafLlas: te,
            GuillotineBafMaxas: se,
            GuillotineBafMinas: ee,
            MaxRectsBl: Jt,
            MaxRectsBssf: Kt,
            MaxRectsBaf: Ht,
            MaxRectsBlsf: Qt,
            float2dec: ne,
            SORT_AREA: Wt,
            SORT_PERI: ie,
            SORT_DIFF: re,
            SORT_SSIDE: oe,
            SORT_LSIDE: le,
            SORT_RATIO: ce,
            SORT_NONE: ae,
            BinFactory: he,
            PackerBNFMixin: ue,
            PackerBFFMixin: fe,
            PackerBBFMixin: _e,
            PackerOnline: de,
            PackingMode: Ct,
            PackingBin: $t,
            newPacker: Ut
        };
        typeof window < "u" && (window.newPacker = Ut,
        window.PackingMode = Ct,
        window.PackingBin = $t,
        window.SORT_AREA = Wt,
        window.GuillotineBssfSas = Dt,
        window.MaxRectsBl = Jt,
        window.MaxRectsBssf = Kt,
        window.MaxRectsBaf = Ht,
        window.MaxRectsBlsf = Qt)
    }
    );
    pe();
}
)();